import { createSlice } from '@reduxjs/toolkit'

const size = createSlice({
    name: 'size',//Данные для виджетов 
    initialState: {
        windowWidth: null,
        windowHeight: null,
        desktop: false,
        mobile: false, //576
        tablet: false //991
    },
    reducers: {
        setWindow(state, action) {
            state.windowWidth = action.payload.width;
            state.windowHeight = action.payload.height;

            if (action.payload.width <= 576) {
                state.mobile = true;
                state.tablet = false;
                state.desktop = false;
            }
            else if (action.payload.width > 576 & action.payload.width <= 991) {
                state.mobile = false;
                state.tablet = true;
                state.desktop = false;
            }
            else {
                state.mobile = false;
                state.tablet = false;
                state.desktop = true;
            }
        }
    }
})

export const { setWindow } = size.actions
export default size.reducer